<flx-resource-header
  [breadcrumbs]="breadcrumbItems"
  [defaultBackMenuItem]="defaultBackMenuItem"
>
  <div
    class="flex flex-row justify-end items-center gap-2 grow"
    resourceHeaderRightContent
  >
    @if (accessRights().canEdit) {
      <button
        [disabled]="readOnly()"
        (click)="openContentValueEditModal(mappedEnumeration())"
        class="primary-btn"
        flxButton
        data-testid="add-value-button"
      >
        Add value
      </button>
    }

    <button
      (click)="menu.toggle($event)"
      class="icon-btn"
      flxButton
      variant="ghost"
      clickStopPropagation
      data-testId="row-menu-button"
    >
      <i class="ph-bold ph-dots-three-vertical"></i>
    </button>
  </div>
</flx-resource-header>
<div
  #view="cdkOverlayOrigin"
  class="p-8 h-full overflow-y-auto"
  cdkOverlayOrigin
>
  <flx-resources-grid
    [tableDef]="enumerationValuesTableCols()"
    [items]="$safeNavigationMigration(mappedEnumeration()?.contentValues)"
    [emptyMsg]="emptyMsg()"
    [uniqueKeys]="['code']"
    class="h-full"
  ></flx-resources-grid>
</div>

<flx-overlay
  [overlayOrigin]="view"
  [(showOverlay)]="showAuditLogsOverlay"
>
  <div class="bg-white h-full">
    @if (showAuditLogsOverlay()) {
      <flx-audit-logs
        [initialQuery]="{
          component: ComponentTypeEnum.CONTENT_MANAGEMENT,
          element: ElementTypeEnum.ENUMERATION,
          identifier: enumerationId(),
          appVersionId: appVersionId(),
        }"
        [resourceName]="enumerationName()"
      />
    }
  </div>
</flx-overlay>

<p-menu
  #menu
  [popup]="true"
  [appendTo]="'body'"
  [model]="contextMenuItems()"
  styleClass="flx-prime-menu"
/>

<ng-template
  #resourceUsagesDelete
  let-data
>
  <flx-resource-usages-delete-confirmation
    [resourceUsages]="data.resourceUsages"
    (viewUsagesClicked)="openResourceUsagesModal(data.enumeration, 'fromDeleteConfirm', $event)"
  ></flx-resource-usages-delete-confirmation>
</ng-template>
